import { Component, OnInit, ViewChild, HostListener, ElementRef } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';

import { AlertService, PhotoauthService, AuthenticationService } from '../_services';
import { Globals } from '../_helpers';

import { Subject } from 'rxjs';
import { Observable, throwError } from 'rxjs';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import swal, { SweetAlertOptions } from 'sweetalert2';
import { SwalComponent } from '@toverux/ngx-sweetalert2';

export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}

@Component({
    selector: 'student-idupload-pic',
    templateUrl: './upload-idpic.component.html',
    styleUrls: ['./upload-idpic.component.css']
})

export class UploadidpicComponent implements OnInit {
    @ViewChild('skippicSwal') private skippicSwal: SwalComponent;
    public alertOption: SweetAlertOptions = {};

    fileFormControl = new FormControl('', [
        Validators.required,
    ]);

    matcher = new MyErrorStateMatcher();

    isMediaAllowed = false;
    showPermissionError = false;
    loading = false;
    submitted = false;
    isPicTaken = true;
    errorMsg : string = 'Image is required !!';  
    returnUrl: string;
    imagePath: string;
    imgfile: File;
    imageError: boolean;
    exam_id: number;
    userData = {};
    settings = {};
    base64: string;
    settime;    

    /* webcam Settings */
    public iscameraLoaded:boolean = false;
    public showWebcam = true;
    public allowCameraSwitch = true;
    public multipleWebcamsAvailable = false;
    public deviceId: string;

    public videoOptions: MediaTrackConstraints = {
        // width: {ideal: 1024},
        // height: {ideal: 576}
    };
    public errors: WebcamInitError[] = [];

    // latest snapshot
    public webcamImage: WebcamImage = null;

    // webcam snapshot trigger
    private trigger: Subject<void> = new Subject<void>();

    // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
    private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private photoauthService: PhotoauthService,
        private alertService: AlertService,
        private authenticationService: AuthenticationService,        
        private globals: Globals,
        private spinner: NgxSpinnerService
    ) { }

    ngOnInit() {
        var step = this.route.snapshot.paramMap.get("step");
        if (step != this.globals.complSteps['upload-idpic'])
            //this.router.navigateByUrl('/login');
        this.imageError = false;
        this.isPicTaken = false;
        this.imagePath = '/assets/images/picid-upload.png';

        // get return url from route parameters or default to '/'
        this.returnUrl = '/';
        this.requestMediaAccess();

        WebcamUtil.getAvailableVideoInputs()
            .then((mediaDevices: MediaDeviceInfo[]) => {
                this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
            });
    }

    requestMediaAccess() {
    navigator.mediaDevices.getUserMedia({ video: true, audio: true })
      .then((stream: MediaStream) => {
        this.isMediaAllowed = true;
        // stop the stream right away since ngx-webcam will trigger it again
        stream.getTracks().forEach(track => track.stop());
      })
      .catch((err) => {
        console.error('Camera/Mic access denied:', err);
        this.showPermissionError = true;
        this.isMediaAllowed = false;
      });
    }
  
    public triggerSnapshot(): void {
        this.trigger.next();
        this.imagePath = this.webcamImage.imageAsDataUrl;
        this.isPicTaken = false;
        this.imageError = false;

    }

    public toggleWebcam(): void {
        this.showWebcam = !this.showWebcam;
    }

    public handleInitError(error: WebcamInitError): void {
        this.errors.push(error);
    }

    public showNextWebcam(directionOrDeviceId: boolean | string): void {
        // true => move forward through devices
        // false => move backwards through devices
        // string => move to device with given deviceId
        this.nextWebcam.next(directionOrDeviceId);
    }

    public handleImage(webcamImage: WebcamImage): void {
        this.webcamImage = webcamImage;
    }

    public cameraWasSwitched(deviceId: string): void {
        this.deviceId = deviceId;
    }

    public get triggerObservable(): Observable<void> {
        return this.trigger.asObservable();
    }

    public get nextWebcamObservable(): Observable<boolean | string> {
        return this.nextWebcam.asObservable();
    }

    public webCameScreen(): void {
        this.isPicTaken = true;
         this.settime = setInterval(() => {
          this.iscameraLoaded = true;
          clearInterval(this.settime);
        }, 5000);       
    }
    canvas;
    imgToCanvas(url) {
        const img = document.createElement("img");
        img.src = url;
        img.setAttribute ("crossorigin", "anonymous"); // prevent failed to execute 'todataurl' on 'htmlcanvas element' caused by cross domain: tainted canvas may not be exported
        //await new Promise((resolve) => (img.onload = resolve));
        //Create the canvas DOM element and set its width and height to be the same as the picture
        const canvas = <HTMLCanvasElement>document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height + (img.height * 0.06);
        //The coordinates (0,0) indicate that the drawing starts from here and is equivalent to an offset.
        canvas.getContext("2d").drawImage(img, 0, 0);
        const ctx = canvas.getContext("2d");
        ctx.beginPath();
        ctx.rect(0, img.height, canvas.width, (img.height * 0.06));
        ctx.fillStyle = "#808080";
        ctx.fill();
        ctx.font = "18px Arial";
        ctx.textBaseline = "bottom";
        ctx.fillStyle = "white";
        ctx.fillText(this.formatDate(new Date()), (img.height)/2, img.height + (img.height * 0.06));
        //var image = new Image();
        var src = canvas.toDataURL("image/jpeg");   
        //console.log(src);
        return src;
    }
    formatDate(date) {
      var dd = date.getDate();
      var mm = date.getMonth() + 1;
      var yy = date.getFullYear();
      var strDate = dd + '-' + mm + '-' + yy;
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0'+minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;      
      return strDate +' '+ strTime;
    }
    watermarkImg;
    onFileSubmit() {
        this.submitted = true;
        if (this.webcamImage && this.webcamImage.imageAsDataUrl) {
            //this.spinner.show();
            this.userData = JSON.parse(localStorage.getItem('currentUser'));
            this.settings = JSON.parse(sessionStorage.pkshn_exam_set);
            const imgUrl = this.webcamImage.imageAsDataUrl; 
            this.watermarkImg = this.imgToCanvas(imgUrl);
            //console.log(this.watermarkImg);
            //this.photoauthService.photoid(this.globals.root_url, this.userData['usercode'], this.userData['userid'], this.userData['subuserid'], this.userData['id'], this.webcamImage.imageAsDataUrl, this.settings['exam_id'])
            if(this.settings['theory2_login'] == 1)
            {
                this.theory2IDProfile();
            }  
            else if(this.settings['entered_psyc'] == 1)
            {
                this.psychoIDProfile();
            }
            else if(this.settings['entered_adaptive'] == 1)
            {
                this.adaptiveIDProfile();
            }       
            else if(this.settings['entered_theory3'] == 1)
            {
                this.theory3IDProfile();
            }                  
            else
            {
                this.photoauthService.photoid(this.globals.root_url, this.userData['usercode'], this.userData['userid'], this.userData['subuserid'], this.userData['id'], this.watermarkImg, this.settings['exam_id'])
                .pipe(first())
                .subscribe(
                    data => {
                        if (data.code == 1000) {
                            this.imageError = false;
                            this.showWebcam = false;
                            this.authStage();
                            var parms = this.globals.getRandUrl('upload-pic');
                            this.router.navigateByUrl('/upload-pic/' + parms);
                        }
                        else if (data.code == 1001) {
                            this.loading = false;
                            this.imageError = true; 
                            this.errorMsg = data.status;
                        }
/*                        else if (data.code == 1002) {
                            this.loading = false;
                            this.router.navigateByUrl('/login');
                        }*/
                        else {
                            this.imageError = true;
                            this.errorMsg = 'Image does not upload please try again !!';
                            this.loading = false;
                        }
                        this.spinner.hide();
                    },
                    error => {
                        this.imageError = true;
                        this.errorMsg = 'Image does not upload please try again !!';
                        this.alertService.error(error);
                        this.loading = false;
                        this.spinner.hide();
                    }
                );
            }          

        }
        else {
            this.imageError = true;
            this.errorMsg = 'Invalid Image !!';
            this.loading = false;
        }
    }
    public theory2IDProfile() {
        this.photoauthService.photoid2web(this.globals.root_url, this.userData['usercode'], this.userData['userid'], this.userData['subuserid'], this.userData['id'], this.watermarkImg, this.settings['exam_id'])
        .pipe(first())
        .subscribe(
            data => {
                if (data.code == 1000) {
                    this.imageError = false;
                    this.showWebcam = false;
                    var parms = this.globals.getRandUrl('upload-pic');
                    this.router.navigateByUrl('/upload-pic/' + parms);
                }
                else if (data.code == 1001) {
                    this.loading = false;
                    this.imageError = true; 
                    this.errorMsg = data.status;
                }
                else if (data.code == 1002) {
                    this.loading = false;
                    this.router.navigateByUrl('/login');
                }
                else {
                    this.imageError = true;
                    this.errorMsg = 'Image does not upload please try again !!';
                    this.loading = false;
                }
                this.spinner.hide();
            },
            error => {
                this.imageError = true;
                this.errorMsg = 'Image does not upload please try again !!';
                this.alertService.error(error);
                this.loading = false;
                this.spinner.hide();
            }
        );
    }
    public psychoIDProfile() {
        this.photoauthService.photoidPsychoweb(this.globals.root_url, this.userData['usercode'], this.userData['userid'], this.userData['subuserid'], this.userData['id'], this.watermarkImg, this.settings['exam_id'])
        .pipe(first())
        .subscribe(
            data => {
                if (data.code == 1000) {
                    this.imageError = false;
                    this.showWebcam = false;
                    var parms = this.globals.getRandUrl('upload-pic');
                    this.router.navigateByUrl('/upload-pic/' + parms);
                }
                else if (data.code == 1001) {
                        this.loading = false;
                        this.imageError = true; 
                        this.errorMsg = data.status;
                }
                else if (data.code == 1002) {
                    this.loading = false;
                    this.router.navigateByUrl('/login');
                }
                else {
                    this.imageError = true;
                    this.errorMsg = 'Image does not upload please try again !!';
                    this.loading = false;
                }
                this.spinner.hide();
            },
            error => {
                this.imageError = true;
                this.errorMsg = 'Image does not upload please try again !!';
                this.alertService.error(error);
                this.loading = false;
                this.spinner.hide();
            }
        );
    }
    public theory3IDProfile() {
        this.photoauthService.photoidTheory3web(this.globals.root_url, this.userData['usercode'], this.userData['userid'], this.userData['subuserid'], this.userData['id'], this.watermarkImg, this.settings['exam_id'])
        .pipe(first())
        .subscribe(
            data => {
                if (data.code == 1000) {
                    this.imageError = false;
                    this.showWebcam = false;
                    this.authStage();
                    var parms = this.globals.getRandUrl('upload-pic');
                    this.router.navigateByUrl('/upload-pic/' + parms);
                }
                else if (data.code == 1001) {
                        this.loading = false;
                        this.imageError = true; 
                        this.errorMsg = data.status;
                }
                else if (data.code == 1002) {
                    this.loading = false;
                    this.router.navigateByUrl('/login');
                }
                else {
                    this.imageError = true;
                    this.errorMsg = 'Image does not upload please try again !!';
                    this.loading = false;
                }
                this.spinner.hide();
            },
            error => {
                this.imageError = true;
                this.errorMsg = 'Image does not upload please try again !!';
                this.alertService.error(error);
                this.loading = false;
                this.spinner.hide();
            }
        );
    }    
    public adaptiveIDProfile() {
        this.photoauthService.photoidAdaptiveweb(this.globals.root_url, this.userData['usercode'], this.userData['userid'], this.userData['subuserid'], this.userData['id'], this.watermarkImg, this.settings['exam_id'])
        .pipe(first())
        .subscribe(
            data => {
                if (data.code == 1000) {
                    this.imageError = false;
                    this.showWebcam = false;
                    var parms = this.globals.getRandUrl('upload-pic');
                    this.router.navigateByUrl('/upload-pic/' + parms);
                }
                else if (data.code == 1001) {
                    this.loading = false;
                    this.imageError = true; 
                    this.errorMsg = data.status;
                }
                else if (data.code == 1002) {
                    this.loading = false;
                    this.router.navigateByUrl('/login');
                }
                else {
                    this.imageError = true;
                    this.errorMsg = 'Image does not upload please try again !!';
                    this.loading = false;
                }
                this.spinner.hide();
            },
            error => {
                this.imageError = true;
                this.errorMsg = 'Image does not upload please try again !!';
                this.alertService.error(error);
                this.loading = false;
                this.spinner.hide();
            }
        );
    }   
    public authStage(){
        this.authenticationService.authStage(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'], 3)
        .pipe(first())
        .subscribe(
            data => {
                if(data.code == 1000){
                    console.log('Auth Stage 3 updated');
                }
            }
        );
    }      
    /*	public checkPhotoAuth(){
            this.spinner.show();
            this.photoauthService.checkPhotoAuth(this.globals.root_url, this.userData['usercode'], this.userData['userid'], this.userData['subuserid'], this.settings['exam_id'],'photo')
            .pipe(first())
            .subscribe(
                data => {
                    if(data.code == 1000){
                        if(data.status == 'yes'){
                            var parms = this.globals.getRandUrl('test-start');
                            this.router.navigateByUrl('/test-start/'+parms);
                        }
                        else{
                            this.skippicSwal.show();
                        }
                    }
                    else if(data.status == 'COM_TOKEN_ERROR'){
                        this.loading = false;
                        this.router.navigateByUrl('/login');
                    }
                    else{
                        
                    }
                    this.spinner.hide();
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                    this.spinner.hide();
                }
            );
        }*/
}
